import React from "react";
import {
  BrowserRouter,
  Route, Routes,
  Navigate
} from "react-router-dom";
import MainAppBar from "./pages/MainAppBar";
import BasicTable from "./pages/BasicTable";
import ConfigForm from "./pages/ConfigForm";
import ListOfCards from "./pages/dashBoard/ListOfCards";
import './App.css';
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { Grid } from "@mui/material";
import ConfigUserList from "./pages/ConfigUserList";
import LicitacaoUserView from "./pages/LicitacaoUserView";
import RequireRole from "./auth/RequireRole";
import { ROLES } from "./auth/roles";
import { hasRoleOrGroup } from "./auth/access";

function Home() {
  useEffect(() => {
    console.log("Home")
  }, [])
  return <h2>Home</h2>;
}

function NotFound() {
  useEffect(() => {
    console.log("bla")
  }, [])
  return <h2>Não encontrado</h2>
}

// Tela inicial: só quem tem "admin" ou "dev" vai pra /home. Todo mundo mais
// (role "user", "visualizador", ou nenhuma role/grupo cadastrado no
// Keycloak) cai direto em /configUser, que é a única área liberada pra
// eles — inclusive quem não está em nenhum grupo, que enxerga a mesma tela
// somente-leitura do "visualizador" (ver ConfigUserService no backend).
function Landing() {
  const temAcessoHome = hasRoleOrGroup(ROLES.ADMIN) || hasRoleOrGroup(ROLES.DEV);
  return <Navigate to={temAcessoHome ? "/home" : "/configUser"} replace />;
}

// Quem chega até aqui já está autenticado no Keycloak (ver src/index.js).
// O que falta é decidir QUAIS telas cada perfil pode ver — isso é feito
// envolvendo cada <Route> com <RequireRole allow={[...]}>.
//
// Hoje a maior parte do sistema é a área administrativa, restrita a
// ROLES.ADMIN. A tela /configUser (e seu detalhe) também é liberada para
// ROLES.USER: cada usuário dessa role só enxerga/edita os próprios registros
// (restrição aplicada de verdade no backend, em ConfigUserService). Para
// liberar uma tela nova para "dev" e/ou "visualizador" no futuro, crie a
// rota normalmente e defina o `allow` dela, por exemplo:
// <RequireRole allow={[ROLES.DEV, ROLES.ADMIN, ROLES.DEV]}>
function App() {
  const [busca, setBusca] = useState();
  const [wait, setWait] = useState(false);

  return (
    <BrowserRouter>
      <Grid>
        <MainAppBar setBusca={setBusca} />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/home" element={<RequireRole allow={[ROLES.DEV, ROLES.ADMIN]}><Home /></RequireRole>} />
          <Route path="/config" element={<RequireRole allow={[ROLES.DEV, ROLES.ADMIN]}><ConfigForm setWait={setWait} /></RequireRole>} />
          {/* allow=[] libera pra QUALQUER usuário autenticado, mesmo sem role/grupo
              nenhum — quem não é admin/dev/user cai no modo somente-leitura
              (igual "visualizador"), restrição aplicada de verdade no backend. */}
          <Route path="/configUser" element={<RequireRole allow={[]}><ConfigUserList setWait={setWait} /></RequireRole>} />
          <Route path="/configUser/view" element={<RequireRole allow={[]}><LicitacaoUserView setWait={setWait} /></RequireRole>} />

          <Route path="/board" element={<RequireRole allow={[ROLES.DEV]}><ListOfCards busca={busca} setWait={setWait} /></RequireRole>} />

          <Route path="/lista" element={<RequireRole allow={[ROLES.DEV]}><BasicTable busca={busca} setWait={setWait} /></RequireRole>} />

          {/* <Route path="/*" element={<NotFound />} /> */}

        </Routes>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={wait}
          onClick={() => setWait(false)}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Grid>
    </BrowserRouter>
  );
}



export default App;
